import React from "react";
import { Navigate, Outlet } from "react-router";
import { CircularProgressBoxWithLabel } from "src/ui/shared/CircularProgressWithLabel";
import { usePrefetch } from "src/ui/utils/usePrefetch";

export const PrefetchGuard = () => {
    const { progress, hasPrefetchError, isResolvingWorkspace } = usePrefetch();

    if (hasPrefetchError) {
        return <Navigate to="/oops" replace />;
    }

    if (isResolvingWorkspace) {
        return null;
    }

    if (progress !== 100) {
        return <CircularProgressBoxWithLabel value={progress} size="large" />;
    }

    return <Outlet />;
};
